module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "epigraph_1"
    }
  }), _c('p', {
    staticClass: "ep"
  }, [_c('em', [_vm._v("I see a red door and I want it painted black,"), _c('br'), _vm._v(" No colors anymore I want them to turn black . . .")])]), _c('p', {
    staticClass: "eps"
  }, [_vm._v("“Paint It Black,” The Rolling Stones")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541e1804","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaintItBlack_epig_1.vue
// module id = 72
// module chunks = 0